import { DateTime } from "luxon";

/**
 * APP-763 rollout window for the gaps home's one-time "what's new" note — one-off campaign boundaries,
 * NOT tunables. A module of its own, with no React in it, so the e2e suites can read the same key and end
 * date instead of re-typing them.
 *
 * - `key` — each user's "Got it" is stored under it, so changing it shows the note to everyone again.
 * - `expiresAt` — after 2027-03-31 the gaps-first view is no longer news; the note stops rendering whether or
 *   not it was ever acknowledged. Fixed in UTC so it closes at the same instant for everyone. Move it if the
 *   `mobile_gaps_view` rollout reaches departments later than planned: a department switched on after this
 *   date never sees the note.
 *
 * No account-age gate: half of the note is the way back to the classic view, which a user who never saw the
 * old screen needs just as much.
 *
 * Once the window closes, delete all of it:
 * - this file, `GapsWhatsNewNotice.tsx` and its render site in `MobileGapsStaffing.tsx`;
 * - the `gaps.whatsNew.*` keys in en / es / he;
 * - the note's paragraph and its three keywords ("new look note", "what's new note", "got it note") in
 *   `backend/services/annie/knowledge/scheduling/mobile-gaps-view.md`, and its two questions in
 *   `backend/tests/annie/test_knowledge_base.py`;
 * - in `frontend/tests/helpers/gapsViewEffects.ts`: `WHATS_NEW_NOTICE_STORAGE_SUFFIX`, `acknowledgeWhatsNew`
 *   and its two calls, and `enableGapsViewFirstVisit`;
 * - in `frontend/tests/admin/mobile-gaps-shell.spec.ts`: the first-visit test, and the `gaps-whats-new`
 *   assertions in the flag-on and flag-off tests.
 */
export const GAPS_WHATS_NEW_NOTICE = {
	key: "app-763-gaps-view-whats-new",
	expiresAt: DateTime.fromISO("2027-03-31", { zone: "utc" }).endOf("day"),
} as const;
